var map = {
	"./Claro-logo.png": 1379,
	"./Claro-logo.svg": 1380,
	"./alvo.png": 1381,
	"./arrow-bottom.png": 326,
	"./arrow-top.png": 327,
	"./audiencia-total.png": 1382,
	"./banner.png": 1383,
	"./beneficio.png": 1384,
	"./calendar.png": 240,
	"./check.png": 1385,
	"./click.png": 1386,
	"./clock.png": 1387,
	"./coin.png": 241,
	"./contratadas.png": 1388,
	"./conversao.png": 1389,
	"./cost-estimated.png": 1390,
	"./cost-total.png": 242,
	"./delete-regular.png": 1391,
	"./delete.png": 1392,
	"./dismiss.png": 1393,
	"./download.png": 1394,
	"./edit-01.svg": 1395,
	"./edit-icon-blue.png": 1396,
	"./edit.png": 1397,
	"./estimated.png": 1398,
	"./icon-log.png": 1399,
	"./impact.png": 1400,
	"./impressao.png": 1401,
	"./interacao.png": 1402,
	"./log-closed.png": 1403,
	"./log-created.png": 1404,
	"./log-created_campaign.png": 1405,
	"./log-demonstration.png": 1406,
	"./log-editing.png": 1407,
	"./log-error.png": 1408,
	"./log-executing.png": 1409,
	"./log-finished.png": 1410,
	"./log-processing.png": 1411,
	"./log-ready.png": 1412,
	"./log-stopped.png": 1413,
	"./log-waiting_approval.png": 1414,
	"./logo-footer.png": 1415,
	"./logo-navbar-old.png": 1416,
	"./logo-navbar.png": 1417,
	"./logo.png": 1418,
	"./mais.png": 1419,
	"./mais.svg": 1420,
	"./mensagem-enviada.png": 1421,
	"./notificacao-patrocinada-dark.png": 577,
	"./notificacao-patrocinada.png": 580,
	"./pin-map.png": 325,
	"./play_arrow.svg": 1422,
	"./pontos.svg": 1423,
	"./preview.png": 328,
	"./printer.png": 1424,
	"./push-notification-dark.png": 576,
	"./push-notification.png": 579,
	"./rewarded-dark.png": 1425,
	"./rewarded.png": 1426,
	"./rosto-sorrindo.svg": 1427,
	"./save-icon-white.png": 1428,
	"./search-icon-green.png": 1429,
	"./send-message.png": 243,
	"./seta-esquerda.svg": 1430,
	"./smile-face.png": 1431,
	"./sms-dark.png": 575,
	"./sms.png": 578,
	"./survey-dark.png": 1432,
	"./survey.png": 1433,
	"./terms-bg.png": 581,
	"./trash-icon-red.png": 1434,
	"./user-icon-navbar.png": 1435
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1378;